import { mxn, fdate } from "@/lib/format";

/** Simulador · Factoraje: resumen de la cuota única (cifras del backend). */
export function FactorajeSimKpis({ result }) {
  const fx = result.factoraje || {};
  const kpis = [
    { l: "Anticipo (valor nominal × aforo)", v: mxn(fx.anticipo), tid: "sim-fx-kpi-anticipo" },
    { l: "Días de descuento", v: fx.dias_descuento ?? "—", tid: "sim-fx-kpi-dias" },
    { l: "Descuento (interés)", v: mxn(fx.descuento), tid: "sim-fx-kpi-descuento" },
    { l: "IVA del descuento", v: mxn(fx.iva_descuento), tid: "sim-fx-kpi-iva" },
    { l: "Total al vencimiento", v: mxn(fx.total_vencimiento), tid: "sim-fx-kpi-total" },
    { l: "Neto desembolso", v: mxn(result.neto_desembolso), tid: "sim-kpi-neto" },
    { l: "CAT (%)", v: result.cat != null ? `${Number(result.cat).toFixed(2)}%` : "—", tid: "sim-kpi-cat" },
    { l: "Fecha de pago", v: fdate(fx.fecha_pago), tid: "sim-fx-kpi-fecha-pago" },
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="sim-factoraje-kpis">
      {kpis.map((x) => (
        <div key={x.tid} data-testid={x.tid} className="rounded-lg border border-slate-200 bg-white p-3 shadow-sm">
          <p className="text-[11px] uppercase tracking-wide text-slate-500">{x.l}</p>
          <p className="mt-1 font-heading text-lg font-semibold tabular-nums text-slate-900">{x.v}</p>
        </div>
      ))}
    </div>
  );
}
